var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"a-tag"},_vm.$listeners),[_c('span',{staticClass:"a-tag__text"},[_vm._t("default")],2),_vm._v(" "),_c('base-icon',{attrs:{"icon":"close"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }